/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// Use this function if no gaps between navigation items and its X-axis (Margin-bottom / Margin-top on Nav-items)
// function setHeaderMargins() {
//     if($(window).scrollTop() === 0) {
//         $(".mega-sub-menu").css('top', '85px');
//     } else {
//         $(".mega-sub-menu").css('top', '70px');
//     }
// }

// Sidebar chat with us (Landing Pages - Mobile only)
$('.sidebar-cta-links_toggle-wrapper').click(function(){
  $(this).siblings('.sidebar-cta-links_wrapper.--responsive-links').slideToggle(150);

  if($(this).siblings('.sidebar-cta-links_wrapper.--responsive-links:visible')) {
    $('.sidebar-cta-links_responsive-icon').toggleClass('active');
  }
});

// Return true if the input field is empty
function checkEmptyField() {
    if( !$("#input_11_1, #input_12_1, #input_13_1, #input_14_1, #input_15_1").val() ) {
        $('.discuss-your-needs_form-handle form').removeClass('form-activated');
    }
}


jQuery(document).on('gform_post_render', function(e, form_id) {
    if ( jQuery('div.validation_error', '#gform_' + form_id).length > 0 ) {
        console.log('Form validation error.' + form_id);
        $('.discuss-your-needs_form-handle form').addClass('form-activated');
        $('.discuss-your-needs_form-handle form li').removeClass('gfield_error');

        // Expand the form so the errors can be seen.
        if (form_id == "16") {
            console.log("triggered form validation");
            jQuery("#gform_16").addClass("form-activated");
        }
    }
});

// DISCUSS YOUR NEEDS - Detect when user adds text to input field (Full Name)
$('#input_11_1, #input_12_1, #input_13_1, #input_14_1, #input_15_1').change( function(e) {
    $('.discuss-your-needs_form-handle form').addClass('form-activated');
    checkEmptyField();
});

// Return true if the input field is empty
function bookAuditCheckEmptyField() {
    if( !$("#input_16_1, #input_16_2, #input_16_7, #input_16_3, #input_16_8, #input_16_9").val() ) {
        $('.book-your-free-it-audit_form-handle form').removeClass('form-activated');
    }
}

// BOOK YOUR FREE IT AUDIT - Detect when user adds text to input field (Full Name)
$('#input_16_1, #input_16_2, #input_16_7, #input_16_3, #input_16_8, #input_16_9').click( function(e) {
    //console.log("hello");
    $('.book-your-free-it-audit_form-handle form').addClass('form-activated');
    // bookAuditCheckEmptyField();
});

// $("#input_16_1").click(function() {
//     alert("hello");
// });

var performanceComparisonElement = $('.products-and-services-grid_performance');
var tableComparisonElement = $('.products-and-services-grid_table');

$('.products-and-services-grid_btn-enable .enquire-btn').click(function() {
    if($(this).hasClass('compare-services')) {
        tableComparisonElement.slideToggle();
    }

    if($(this).hasClass('check-performance')) {
        performanceComparisonElement.slideToggle();
    }
});

var chatBox = {
    hide: false
};

var CCData = {
    postcode: 'unknown',
    address: 'unknown',
    cssDistrictCode: 'unknown',
    alk: 'unknown'
};

var CCGeneralSettings = {
    statusCheckRate: 5000,
    statusTimeout: 60000,
};

var CCProductSegments = {
    oddImage: 'https://www.razorblue.com/wp-content/uploads/2019/12/odd-background.jpg',
    evenImage: 'https://www.razorblue.com/wp-content/uploads/2019/12/even-background.jpg',
    state: 'odd'
};

/* The total quotes may not always be the total quotes because the API
 * only returns how many it has remaining. Should be suitable for percentage bar though.
 */
var CCDStatus = {
    quotesRemaining: null,
    foundQuotes: null,
    totalQuotes: null,
    initialRun: true,
    statusTally:0
};

/**
 * Some of these are no longer used since the addition of the hardcoded features (CCDFeaturesHTML)
 * but they are still read from the API and written here
 */
var CCDFibre = {
    lowestUpload: null,
    lowestDownload: null,
    highestUpload: null,
    highestDownload: null,
    minimumPrice: null,
    lowestSla: 'unknown',
    qos: 'yes',
    shortestInstallationDate: 'unknown',
    initialCheck: true
};

var CCDWirelessLeasedLine = {
    lowestUpload: null,
    lowestDownload: null,
    highestUpload: null,
    highestDownload: null,
    minimumPrice: null,
    lowestSla: 'unknown',
    qos: 'yes',
    shortestInstallationDate: 'unknown',
    initialCheck: true
};

/*
 * Any API endpoints are specified here.
 * @type {{checkPostcode: string, requestQuote: string, status: string, quote: string}}
 */
var CCEndpoints = {
    checkPostcode: 'https://www.razorblue.com/qutool/check-postcode.php',
    requestQuote: 'https://www.razorblue.com/qutool/request-quotes.php',
    status: 'https://www.razorblue.com/qutool/status.php',
    quote: 'https://www.razorblue.com/qutool/quote.php',
};

function usingMsie()
{
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
        return true;
    }
    else  // If another browser, return 0
    {
        return false;
    }
}

/**
 *  This array is used to build the features section.
 */

var CCDFeaturesHTML = {
  ADSL:
    '<ul class="features-list">' +
    '<li><p>Typically installed within 1 week</p></li>' +
    '</ul>',
  FTTC:
    '<ul class="features-list">' +
    '<li><p>Typically installed within 1 week</p></li>' +
    '<li><p>Hybrid copper and fibre service</p></li>' +
    '</ul>',
  FTTP:
    '<ul class="features-list">' +
    '<li><p>Typically installed within 1 week</p></li>' +
    '<li><p>Full fibre service to the building</p></li>' +
    '</ul>',
  EFM:
    '<ul class="features-list">' +
    '<li><p>Typically installed within 2 weeks</p></li>' +
    '<li><p>Guaranteed speeds even at peak times</p></li>' +
    '<li><p>Guaranteed 7 hour fault-fix</p></li>' +
    '<li><p>Bonded copper service</p></li>' +
    '<li><p>Supports QoS for excellent voice &amp; video performance</p></li>' +
    '</ul>',
  EoFTTC:
    '<ul class="features-list">' +
    '<li><p>Typically installed within 2 weeks</p></li>' +
    '<li><p>Guaranteed speeds even at peak times</p></li>' +
    '<li><p>Guaranteed 7 hour fault-fix</p></li>' +
    '<li><p>Hybrid copper and fibre service</p></li>' +
    '<li><p>Supports QoS for excellent voice &amp; video performance</p></li>' +
    '</ul>',
  Fibre:
    '<ul class="features-list">' +
    '<li><p>Typically installed within 6 weeks</p></li>' +
    '<li><p>Guaranteed speeds even at peak times</p></li>' +
    '<li><p>Guaranteed 4 hour fault-fix</p></li>' +
    '<li><p>Full fibre solution to the building</p></li>' +
    '<li><p>Supports QoS for excellent voice &amp; video performance</p></li>' +
    '</ul>',
  Wireless:
    '<ul class="features-list">' +
    '<li><p>Typically installed within 1 week</p></li>' +
    '<li><p>Guaranteed speeds even at peak times</p></li>' +
    '<li><p>Guaranteed 4 hour fault-fix</p></li>' +
    '<li><p>Delivered via secure microwave wireless link</p></li>' +
    '<li><p>Supports QoS for excellent voice &amp; video performance</p></li>' +
    '</ul>'
};

var CoverageCheckerValidation = {
    quoteExistsStatus: function(result) {
        try {
            var resultsJSON = JSON.parse(result);
            return resultsJSON.errors.error;
        } catch(e) {
            return false;
        }
    },

    hitRateLimits: function(result) {
        try {
            var resultsJSON = JSON.parse(result);
            //console.log(resultsJSON);

            if (resultsJSON.errors.errorCode === "1002" &&
                resultsJSON.errors.error === true) {
                return true;
            }
        } catch (e) {
            return false;
        }

        return false;
    },

    errorFlagged: function(result) {

    }
};

/*
 * Grouping all functions related to the coverage checker results page.
 */
var CoverageCheckerResults = {

    drawGlobalError: function() {

    },

    showFooterCta: function() {
        $('.available-footer-cta-wrapper').fadeIn();
    },

    getFeaturesHTML: function(type) {
        var html;

        switch (type) {
            case 'ADSL':
                html = CCDFeaturesHTML.ADSL;
                break;
            case 'FTTC':
                html = CCDFeaturesHTML.FTTC;
                break;
            case 'FTTP':
                html = CCDFeaturesHTML.FTTP;
                break;
            case 'EFM':
                // EFM is EFM, can’t really do much about it
                html = CCDFeaturesHTML.EFM;
                break;
            case 'EoFTTC':
                // same
                html = CCDFeaturesHTML.EoFTTC;
                break;
            case 'Fibre':
                html = CCDFeaturesHTML.Fibre;
                break;
            case 'Wireless':
                html = CCDFeaturesHTML.Wireless;
                break;
            default:
                html = CCDFeaturesHTML.Generic;
            }

            return html;
    },

    getUrlParameter: function(name) {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    getQuoteId: function() {
        return CoverageCheckerResults.getUrlParameter('quoteid');
    },

    showLoading: function() {
        $('.progress-bar-container').show();
        $('#ajax-poll').show();
        $('.main-carousel').show();
        $('.availability-title h1').html('Checking availability in your area');
        $('#availability-results-loaded').hide();
        $('.status-specifics-area').show();
    },

    showResults: function() {
        $('.progress-bar-container').hide();
        $('#ajax-poll').hide();
        $('.status-specifics-area').hide();
        $('.main-carousel').hide();
        $('.availability-title h1').html('Available Connectivity');
        $('#availability-results-loaded').fadeIn();
    },

    getPercentageComplete: function() {
        //console.log("total quotes" + CCDStatus.totalQuotes);
        //console.log("quotes remaining" + CCDStatus.quotesRemaining);
        var difference = (CCDStatus.totalQuotes - CCDStatus.quotesRemaining);
        var percentage = (difference / CCDStatus.totalQuotes) * 100;

        return percentage;
    },

    drawPercentage: function() {
        var percentage = CoverageCheckerResults.getPercentageComplete();
        var roundedPercentage = percentage.toFixed(0);

        //console.log(roundedPercentage);
        if (roundedPercentage === 'NaN') {
            roundedPercentage = 100;
        }

        $('#loading-percentage').html(String(roundedPercentage) + '%');
    },

    drawQuotesRemaining: function() {
        var html;

        if (CCDStatus.quotesRemaining === 0) {
            html = "All quotes retrieved, redirecting";
        } else {
            html = CCDStatus.quotesRemaining + ' quotes remaining ';
        }

        $('.status-specifics-area p').html(html);
    },

    drawAddress: function() {
        $('#available-location').html(CCData.address);
    },

    quoteComplete: function() {
        if (CCDStatus.quotesRemaining === 0) {
            return true;
        } else {
            return false;
        }
    },

    saveQuoteStatus: function(result) {
        var quoteStatusArray = JSON.parse(result);

        CCDStatus.foundQuotes = quoteStatusArray[0].quotes;
        CCDStatus.quotesRemaining = quoteStatusArray[0].remaining;
    },

    saveTotalQuotes: function(result) {
        var quoteStatusArray = JSON.parse(result);

        CCDStatus.totalQuotes = quoteStatusArray[0].remaining;
        CCDStatus.initialRun = false;
    },

    saveAddress: function (result) {
        var quoteResults = JSON.parse(result);

        CCData.address = quoteResults.Address.Address;
        CCData.postcode = quoteResults.Address.Postcode;
    },

    updateUI: function() {
        CoverageCheckerResults.drawQuotesRemaining();
        CoverageCheckerResults.drawPercentage();
    },

    // Draw to Block Format (Original)
    // drawUnAvailablePackage: function(currentOption) {
    //     var html = '<div class="availability-offer-row not-available">' +
    //         '<div class="available-offer"><img src="https://staging.razorblue.com/wp-content/uploads/2019/11/not-available-icon.svg"></div>' +
    //         '<div class="available-offer"><h5>' + currentOption.Type + '</h5></div>' +
    //     '<div class="available-offer"><em>Service not available in your area</em></div>' +
    //     '<div class="available-offer">' +
    //         '<div class="pricing-cta">' +
    //         '<div class="available-offer">X</div>' +
    //         '<div class="available-offer"><a href="">Send me my full quote</a></div>' +
    //     '</div>' +
    //     '</div>' +
    //     '</div>';
    //
    //     $('#availability-custom-results').append(html);​
    // },
    //
    // drawAvailablePackage: function(currentOption) {
    //     var html =
    //     '<div class="availability-offer-row">' +
    //       '<div class="available-offer"><img src="https://staging.razorblue.com/wp-content/uploads/2019/11/available-icon.svg"></div>' +
    //       '<div class="available-offer"><h5>' + currentOption.Type + '</h5></div>' +
    //       '<div class="available-offer"><p>Expected Speeds:<br/><strong>' + currentOption.downloadrate + ' Download - ' + currentOption.uploadrate + ' Upload</strong></p>' + currentOption.installationdate  + '</div>' +
    //         '<div class="available-offer">' +
    //         '<div class="pricing-cta">' +
    //         '<div class="available-offer"><p>Packages from:<br/><span class="price-range">£' + currentOption.pricefrom + '</span> / monthly</p></div>' +
    //         '<div class="available-offer"><a href="#" data-toggle="modal" data-target="#coverage-modal">Send me my full quote</a></div>' +
    //       '</div>' +
    //       '</div>' +
    //     '</div>';
    //
    //     $('#availability-custom-results').append(html);​
    // },

    getQosImage: function(qos) {

        if (qos.toLowerCase() === 'yes') {
            return 'https://www.razorblue.com/wp-content/uploads/2019/12/available-icon.svg';
        } else {
            return 'https://www.razorblue.com/wp-content/uploads/2019/12/cross-icon.svg';
        }
    },

    formatSpeeds: function(speed) {
        var formattedSpeed;

        //console.log("in format speeds");
        //console.log(speed);

        if (speed.indexOf("GB") !== -1) {
            formattedSpeed = speed.replace("GB", "");
            formattedSpeed = formattedSpeed.trim();
            formattedSpeed = Math.floor(formattedSpeed) + " GB";
        } else if (speed.indexOf("MB") !== -1) {
            formattedSpeed = speed.replace("MB", "");
            formattedSpeed = formattedSpeed.trim();
            formattedSpeed = Math.floor(formattedSpeed) + " MB";
        } else {
            formattedSpeed = speed;
        }

        return formattedSpeed;
    },

    lowestSla: function(challengerSla, standingSla) {
        //console.log("lowest SLA");
        var challengerSlaInt = challengerSla.replace('Hours', '');
        var standingSlaInt = standingSla.replace('Hours', '');

        if (challengerSla === 'unknown') {
            return standingSla;
        } else if (challengerSla == null) {
            return standingSla;
        } else if (challengerSlaInt < standingSlaInt) {
            return challengerSla;
        } else {
            return standingSla;
        }
    },

    lowestInstall: function(challengerInstall, standingInstall) {
        var challengerInstallInt = challengerInstall.replace('weeks', '');
        var standingInstallInt = standingInstall.replace('weeks', '');

        if (challengerInstall === 'unknown') {
            return standingInstall;
        } else if (challengerInstall == null) {
            return standingInstall;
        } else if (challengerInstallInt < standingInstallInt) {
            return challengerInstall;
        } else {
            return standingInstall;
        }
    },

    lowestSpeed: function(challengerSpeed, standingSpeed) {
        var standingSpeedInt;
        var challengerSpeedInt;

        if (challengerSpeed === 'unknown') {
            return standingSpeed;
        } else if (standingSpeed == null) {
            return challengerSpeed;
        } else {
            if (challengerSpeed.indexOf("GB") !== -1) {
                // If the standing speed is in MB, GB MB trumps the existing one.
                if (standingSpeed.indexOf("MB") !== -1) {
                    return standingSpeed;
                } else if (standingSpeed.indexOf("GB") !== -1) {
                    // Both are gig speeds so now compare them and return largest
                    standingSpeedInt = standingSpeed.replace("GB", "").trim();
                    challengerSpeedInt = challengerSpeed.replace("GB", "").trim();

                    if (parseInt(challengerSpeedInt) < parseInt(standingSpeedInt)) {
                        return challengerSpeed;
                    } else {
                        return standingSpeed;
                    }
                }
            }

            if (challengerSpeed.indexOf("MB") !== -1) {
                if (standingSpeed.indexOf("GB") !== -1) {
                    return challengerSpeed;
                } else if (standingSpeed.indexOf("MB") !== -1) {
                    // Both are MB speeds so now compare them and return largest
                    standingSpeedInt = standingSpeed.replace("MB", "").trim();
                    challengerSpeedInt = challengerSpeed.replace("MB", "").trim();

                    if (parseInt(challengerSpeedInt) < parseInt(standingSpeedInt)) {
                        return challengerSpeed;
                    } else {
                        return standingSpeed;
                    }
                }
            }
        }
    },

    lowestPrice: function(challengerPrice, standingPrice) {

        if (challengerPrice === 'unknown') {
            return standingPrice;
        } else if (standingPrice == null) {
            return challengerPrice;
        } else if (challengerPrice < standingPrice) {
            return challengerPrice;
        } else {
            return standingPrice;
        }
    },

    highestSpeed: function(challengerSpeed, standingSpeed) {
        var standingSpeedInt;
        var challengerSpeedInt;

        if (challengerSpeed === 'unknown') {
            return standingSpeed;
        } else if (standingSpeed == null) {
            return challengerSpeed;
        } else {
            if (challengerSpeed.indexOf("GB") !== -1) {
                // If the standing speed is in MB, GB already trumps the existing one.
                if (standingSpeed.indexOf("MB") !== -1) {
                    return challengerSpeed;
                } else if (standingSpeed.indexOf("GB") !== -1) {
                    // Both are gig speeds so now compare them and return largest
                    standingSpeedInt = standingSpeed.replace("GB", "").trim();
                    challengerSpeedInt = challengerSpeed.replace("GB", "").trim();

                    if (parseInt(challengerSpeedInt) < parseInt(standingSpeedInt)) {
                        return standingSpeed;
                    } else {
                        return challengerSpeed;
                    }
                }
            }

            if (challengerSpeed.indexOf("MB") !== -1) {
                if (standingSpeed.indexOf("GB") !== -1) {
                    return standingSpeed;
                } else if (standingSpeed.indexOf("MB") !== -1) {
                    // Both are MB speeds so now compare them and return largest
                    standingSpeedInt = standingSpeed.replace("MB", "").trim();
                    challengerSpeedInt = challengerSpeed.replace("MB", "").trim();

                    if (parseInt(challengerSpeedInt) < parseInt(standingSpeedInt)) {
                        return standingSpeed;
                    } else {
                        return challengerSpeed;
                    }
                }
            }
        }

        return standingSpeed;
    },

    setFibreMinMax: function(currentOption) {
        if (currentOption.line === 'Fibre') {
            CCDFibre.highestDownload = currentOption.highdownloadrate;
            CCDFibre.lowestDownload = currentOption.lowdownloadrate;

            CCDFibre.highestUpload = currentOption.highuploadrate;
            CCDFibre.lowestUpload = currentOption.lowuploadrate;

            CCDFibre.minimumPrice = CoverageCheckerResults.lowestPrice(currentOption.pricefrom, CCDFibre.minimumPrice);

            CCDFibre.lowestSla = CoverageCheckerResults.lowestSla(currentOption.sla, CCDFibre.lowestSla);
            CCDFibre.shortestInstallationDate = CoverageCheckerResults.lowestInstall(currentOption.installationdate, CCDFibre.shortestInstallationDate);
        }
    },

    setWirelessLeasedLineMinMax: function(currentOption) {
        if (currentOption.line === 'Wireless') {
            CCDWirelessLeasedLine.available = currentOption.Available;
            CCDWirelessLeasedLine.highestDownload = currentOption.highdownloadrate;
            CCDWirelessLeasedLine.lowestDownload = currentOption.lowdownloadrate;

            CCDWirelessLeasedLine.highestUpload = currentOption.highuploadrate;
            CCDWirelessLeasedLine.lowestUpload = currentOption.lowuploadrate;

            CCDWirelessLeasedLine.minimumPrice = CoverageCheckerResults.lowestPrice(currentOption.pricefrom, CCDWirelessLeasedLine.minimumPrice);

            CCDWirelessLeasedLine.lowestSla = CoverageCheckerResults.lowestSla(currentOption.sla, CCDWirelessLeasedLine.lowestSla);
            CCDWirelessLeasedLine.shortestInstallationDate = CoverageCheckerResults.lowestInstall(currentOption.installationdate, CCDWirelessLeasedLine.shortestInstallationDate);
        }
    },

    pluralWeeks: function(week) {
        var numberOfWeeks = week.replace('Typically installed within ', '').replace('week', '');

        if (numberOfWeeks > 1) {
            return 'weeks';
        }

        return 'week';
    },

    getRowBackgroundImage: function() {
        console.log(CCProductSegments.state);

        if (CCProductSegments.state === 'odd') {
            CCProductSegments.state = 'even';
            return CCProductSegments.oddImage;
        } else if (CCProductSegments.state === 'even')  {
            CCProductSegments.state = 'odd';
            return CCProductSegments.evenImage;
        }
    },

    drawFibrePackage: function() {
        var selectedSection = CoverageCheckerResults.getSection('Fibre Leased Line');

        /*
         * This background image is hardcoded. So fibre will always be 'even' as it starts at the top and
         * the loop for the normal packages starts at odd so it should always alternate properly (odd even and ignore
         * the non available ones).
         */
        var html =
          '<div class="offer available" style="background: url(https://www.razorblue.com/wp-content/uploads/2019/12/even-background.jpg);background-size: cover; background-repeat: no-repeat;">' +
            '<div class="available-offer">' + '<h4>' + CoverageCheckerResults.sectionTranslate('Fibre') + '</h4>' +
            '<p>From <strong>' +CCDFibre.lowestDownload + '</strong> to <strong>' +  CCDFibre.highestDownload + '</strong> download <br/>' +
            'From <strong>' + CCDFibre.lowestUpload + '</strong> to <strong>' + CCDFibre.highestDownload + '</strong> upload</p>' +
            '</div>' +
            '<div class="available-offer">' + CoverageCheckerResults.getFeaturesHTML('Fibre') + '</div>' +
            '<div class="available-offer"><p>Pricing from</p><p><span class="price-range">£' + Math.ceil(CCDFibre.minimumPrice) + ' </span> / monthly</p></div>' +
            '<div class="available-offer">' + '<a onclick="CoverageCheckerResults.writeSelectedPackageToForm(CoverageCheckerResults.sectionTranslate(\'Fibre\'))" href="#" data-toggle="modal" data-target="#coverage-modal" style="text-align: center">Email me my quote</a>' + '</div>' +
          '</div>';

        $(selectedSection).prepend(html);
    },

    drawWirelessLeasedLinePackage: function() {
            var selectedSection = CoverageCheckerResults.getSection('Wireless Leased Line');
            //console.log("here");
            //console.log(CCDWirelessLeasedLine);

            var html =
                '<div class="offer available" style="background: url(' + CoverageCheckerResults.getRowBackgroundImage() + ');background-size: cover; background-repeat: no-repeat;">' +
                '<div class="available-offer">' + '<h4>' + CoverageCheckerResults.sectionTranslate('Wireless') + '</h4>' +
                '<p>From <strong>' + CCDWirelessLeasedLine.lowestDownload + '</strong> to <strong>' + CCDWirelessLeasedLine.highestDownload + '</strong> download <br/>' +
                'From <strong>' + CCDWirelessLeasedLine.lowestUpload + '</strong> to <strong>' + CCDWirelessLeasedLine.highestDownload + '</strong> upload</p>' +
                '</div>' +
                '<div class="available-offer">' + CoverageCheckerResults.getFeaturesHTML('Wireless') + '</div>' +
                '<div class="available-offer"><p>Pricing from</p><p><span class="price-range">£' + Math.ceil(CCDWirelessLeasedLine.minimumPrice) + ' </span> / monthly</p></div>' +
                '<div class="available-offer">' + '<a onclick="CoverageCheckerResults.writeSelectedPackageToForm(\'wireless\')" href="#" data-toggle="modal" data-target="#coverage-modal" style="text-align: center">Email me my quote</a>' + '</div>' +
                '</div>';

            $(selectedSection).prepend(html);

    },

    // Draw to Table Format
    drawUnAvailablePackage: function(currentOption, selectedSection) {
      var html =
        '<div class="offer unavailable">' +
          '<div class="available-offer"><h4>' + CoverageCheckerResults.sectionTranslate(currentOption.Type) + '</h4></div>' +
          '<div class="available-offer"><img src="https://www.razorblue.com/wp-content/uploads/2019/12/blue-cross-icon-tiny.svg"><strong><em>Service not available in your area</em></strong></div>' +
        '</div>';
      $(selectedSection).append(html);
    },

    drawAvailablePackage: function(currentOption, selectedSection) {

      // TODO the replace is a temporary fix for NB to style so we need to get this done on the API end.
      var html =
        '<div class="offer available" style="background: url(' + CoverageCheckerResults.getRowBackgroundImage() + '); background-size: cover; background-repeat: no-repeat;">' +
          '<div class="available-offer">' + '<h4>' + CoverageCheckerResults.sectionTranslate(currentOption.Type) + '</h4>' + '<div class="pricing-cta">' + '</div>' +
          '<p>Estimated <strong>' + CoverageCheckerResults.formatSpeeds(currentOption.downloadrate) + ' Download </strong><br/><strong>' + CoverageCheckerResults.formatSpeeds(currentOption.uploadrate) + ' Upload</strong></p>' +
          '</div>' +
          '<div class="available-offer">' + CoverageCheckerResults.getFeaturesHTML(currentOption.Type) + '</div>' +
          '<div class="available-offer"><p>Pricing from</p><p><span class="price-range">£' + Math.ceil(currentOption.pricefrom) + ' </span> / monthly</p></div>' +
          '<div class="available-offer">' + '<a onclick="CoverageCheckerResults.writeSelectedPackageToForm(CoverageCheckerResults.sectionTranslate(\'' + currentOption.Type + '\'))" href="#" data-toggle="modal" data-target="#coverage-modal" style="text-align: center">Email me my quote</a>' + '</div>' +
        '</div>';

      $(selectedSection).append(html);
    },

    sectionTranslate: function(type) {
        var translation;
        //debugger;
        switch(type) {
            case 'ADSL':
                translation = 'Traditional Broadband';
                break;
            case 'FTTC':
                translation = 'Fibre Broadband';
                break;
            case 'FTTP':
                translation = 'Full Fibre Broadband';
                break;
            case 'EFM':
                // EFM is EFM, can’t really do much about it
                translation = 'EFM';
                break;
            case 'EoFTTC':
                // same
                translation = 'EoFTTC';
                break;
            case 'Fibre':
                translation = 'Fibre Leased Line';
                break;
            case 'Wireless':
                translation = 'Wireless Leased Line';
                break;
            default:
                translation = type;
        }

        return translation;
    },


    getSection: function(type) {
        var sectionId;

        if (type === 'ADSL' || type === 'FTTC' || type === 'FTTP') {
            sectionId = '#entry-availability-results-table';
        } else if (type === 'EoFTTC' || type === 'EFM' ) {
            sectionId = '#intermediate-availability-results-table';
        } else if (type === 'Fibre Leased Line' || type === 'Wireless Leased Line') {
            sectionId = '#professional-availability-results-table';
        }

        /**
         * No need for seperation so set it to a single table.
         * Code above has been left in case this is reverted back.
         */
        sectionId = '#availability-custom-results-table';

        return sectionId;
    },

    drawResultsRows: function(result) {
        var currentOption;
        var sectionId;
        var resultsArray = JSON.parse(result);


        for (var i = 0; i < resultsArray["connectivity-options"].length; i++) {
            currentOption = resultsArray["connectivity-options"][i];

            sectionId = CoverageCheckerResults.getSection(currentOption.Type);

            if ((currentOption.Type === 'Fibre Leased Line') && (currentOption.Available === 'Available')) {
                CoverageCheckerResults.setFibreMinMax(currentOption);
            } else if ((currentOption.Type === 'Wireless Leased Line') && (currentOption.Available === 'Available')) {
                    CoverageCheckerResults.setWirelessLeasedLineMinMax(currentOption);
                    CoverageCheckerResults.drawWirelessLeasedLinePackage();
            } else if (currentOption.Available === 'Available') {
                CoverageCheckerResults.drawAvailablePackage(currentOption, sectionId);
            } else {
                CoverageCheckerResults.drawUnAvailablePackage(currentOption, sectionId);
            }
        }
    },

    drawResults: function() {
        var quoteId = CoverageCheckerResults.getQuoteId();

        // Keep polling status endpoint and updating UI until 100% complete
        $.ajax({
            url: CCEndpoints.quote,
            data: {
                quoteid: quoteId
            },
            success: function (result) {
                CoverageCheckerResults.saveAddress(result);
                CoverageCheckerResults.drawAddress();
                CoverageCheckerResults.drawResultsRows(result);
                CoverageCheckerResults.drawFibrePackage();
                CoverageCheckerResults.showFooterCta();
            }
        });
    },

    /* writeQuoteIdToForm: function(quoteId) {
        $('#input_9_18').val("The quote id is: " + quoteId + ". ");
    },

    writeSelectedPackageToForm: function(selectedPackage) {
        //console.log("selected package: " + selectedPackage);
        var existingContent = $('#input_9_18').val();
        var selectedPackageMessage = "Selected package: " + selectedPackage;

        $('#input_9_18').val(existingContent + selectedPackageMessage);
    }, */

	writeQuoteIdToForm: function(quoteId) {
		$('#input_9_27').val(quoteId);
    },

    writeSelectedPackageToForm: function(selectedPackage) {
		$('#input_9_26').val(selectedPackage);
    },

    drawQuoteDoesNotExist: function() {
        $('.main-carousel').hide();
        $('.quote-does-not-exist').show();
    },

    checkQuoteStatus: function() {
        var quoteId = CoverageCheckerResults.getQuoteId();

        // Keep polling status endpoint and updating UI until 100% complete
        $.ajax({
            url: CCEndpoints.status,
            data: {
                quoteid: quoteId
            },
            success: function (result) {
                //console.log(result);
                if (CoverageCheckerValidation.quoteExistsStatus(result) === false) {
                    //console.log("quote exists");
                    CoverageCheckerResults.saveQuoteStatus(result);
                    CoverageCheckerResults.writeQuoteIdToForm(quoteId);

                    if (CCDStatus.initialRun === true) {
                        CoverageCheckerResults.saveTotalQuotes(result);
                    }

                    CoverageCheckerResults.updateUI();
                } else {
                    CoverageCheckerResults.drawQuoteDoesNotExist();
                    clearInterval(refreshId);
                }
            }
        });
    },

    run: function()
    {
        var refreshId = setInterval(function() {
            //console.log("init");
            CoverageCheckerResults.checkQuoteStatus(refreshId);

            if (CoverageCheckerResults.quoteComplete()) {
                CoverageCheckerResults.drawResults();
                CoverageCheckerResults.showResults();
                clearInterval(refreshId);
            }
        }, CCGeneralSettings.statusCheckRate);
    }
};


/*
 *Grouping all functions related to the  coverage checker strip.
 */
var CoverageCheckerStrip = {
    openCoverage: function(result)
    {
        //console.log("open coverage");
        try {
            // First check rate limits
            if(CoverageCheckerValidation.hitRateLimits(result)) {
                CoverageCheckerStrip.showWarning("Request limit reached, please try again later.");
                return true;
            }

            var resultsArray = JSON.parse(result);
            var quoteId = resultsArray[0].id;

            if (quoteId) {
                window.open('/check-availability?quoteid=' + quoteId, "_self");
            } else {
                CoverageCheckerStrip.showWarning('Could not retrieve quote id. ' +
                    'Please <a href="/contact-us">contact us</a> for your quote');
            }
        } catch(e) {
            //console.log(result);
            CoverageCheckerStrip.showWarning('Could not retrieve quote id. ' +
                'Please <a href="/contact-us">contact us</a> for your quote');
        }
    },

    showWarning: function(warning)
    {
        $('.check-coverage-wrapper .drop-col').hide();
        $('.check-coverage-wrapper #coverage-error-message').html("<p>" + warning + "</p>");
        $('.check-coverage-wrapper #coverage-error-message').show();
    },

    hideWarning: function()
    {
        $('.check-coverage-wrapper #coverage-error-message').hide();
    },

    showPostcodeLoader: function() {
      if ($(window).width() <= 767) {
        $('.postcode-loading.loader-md-down').show();
      } else if($(window).width() >= 768) {
        $('.postcode-loading.loader-md-up').show();
      }
    },
    hidePostcodeLoader: function() {
        $('.postcode-loading').hide();
    },

    showAddressSelector: function()
    {
        $('.check-coverage-wrapper #coverage-error-message').hide();
        $('.check-coverage-wrapper .drop-col').css('display', 'flex');
        $('#address-selector-wrapper').css('max-width','100%');

        if (usingMsie()) {
            $('.address-selector').css('width', '600px');
            $('#address-selector-wrapper').css('display', 'block');
        }
    },

    clearAddressSelector: function() {
        $('#address-selector').find('option').remove();
    },

    drawAddressSelector: function(addressJSONString)
    {
        var optionString;
        var currentAddress;

        try {
            var addressArray = JSON.parse(addressJSONString);

            CoverageCheckerStrip.clearAddressSelector();

            for (var i = 0; i < addressArray.Addresses.length; i++) {
                currentAddress = addressArray.Addresses[i];
                optionString = '<option value="' + currentAddress.alk + '|' + currentAddress.address + '|' +
                    currentAddress.districtCode + '">' + currentAddress.address + '</option>';

                $('#address-selector').append(optionString);
            }
        } catch (e) {
            CoverageCheckerStrip.showWarning('Could not retrieve addresses using the postcode. ' +
                'Please check your postcode');
        }
    },

    formatPostcode: function(postcode)
    {
        var postcodeUppercase = postcode.toUpperCase().trim();
        var parts = postcodeUppercase.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
        try {
            parts.shift();
            return (parts.join(' '));
        } catch(e) {
            CoverageCheckerStrip.showWarning("Invalid postcode - please check and try again");
            return false;
        }
    },

    formatPostcodeField: function(postcode)
    {
        $('#postcode').val(postcode);
    },

    validatePostcode: function(rawField)
    {
        if (rawField === "") {
            CoverageCheckerStrip.showWarning("Please enter a postcode");
            return false;
        }

        return CoverageCheckerStrip.formatPostcode(rawField);
    },

    setAddressSelected: function() {
            var selectedAddress = $("#address-selector").val();
            var selectedAddressArray = selectedAddress.split('|');

            CCData.alk = selectedAddressArray[0];
            CCData.address = selectedAddressArray[1];
            CCData.cssDistrictCode = selectedAddressArray[2];
    },

    initFindAddressButton: function()
    {
        $("#find-address-button").click(function () {
            CoverageCheckerStrip.hideWarning();
            const rawPostcode = jQuery('.check-coverage-wrapper #postcode').val();
            CCData.postcode = CoverageCheckerStrip.validatePostcode(rawPostcode);

            // If postcode is valid run the call
            if (CCData.postcode !== false) {
                CoverageCheckerStrip.formatPostcodeField(CCData.postcode);
                CoverageCheckerStrip.showPostcodeLoader();

                $.ajax({
                    url: CCEndpoints.checkPostcode,
                    data: {
                        postcode: CCData.postcode
                    },
                    success: function (result) {
                        //console.log(result);
                        // TODO If response is valid, draw and display address selector
                        CoverageCheckerStrip.drawAddressSelector(result);
                        CoverageCheckerStrip.showAddressSelector();
                        CoverageCheckerStrip.hidePostcodeLoader();
                        // TODO otherwise show warning
                    }
                });
            }
        });
    },

    initCheckAvailabilityButton: function() {
        $('#check-availability-btn').click(function () {
            CoverageCheckerStrip.setAddressSelected();

            $.ajax({
                url: CCEndpoints.requestQuote,
                data: {
                    alk: CCData.alk,
                    address : CCData.address,
                    cssDistrictCode : CCData.cssDistrictCode,
                    postcode: CCData.postcode
                },
                success: function (result) {
                    console.log(this.url);
                    CoverageCheckerStrip.openCoverage(result);
                }
            });
        });
    },

    run: function()
    {
        CoverageCheckerStrip.initFindAddressButton();
        CoverageCheckerStrip.initCheckAvailabilityButton();
    }
};

/**
 * The reason for this is that the site now uses a CDN called fastly so an ajax call to a json endpoint that is not cached is
 * required.
 */
function drawStatusIcon() {
    $.ajax({
        url: 'https://status.razorblue.com/external/',
        success: function (result) {
            if (result.status !== false) {
                $('#header-status-icon').attr("src", "https://www.razorblue.com/wp-content/uploads/2019/10/status-tick-icon-primary.svg");
            } else {
                $('#header-status-icon').attr("src", "https://www.razorblue.com/wp-content/uploads/2019/10/network-status-icon-orange.svg");
            }
        }
    });
}

function showChatBox() {
    $.ajax({
        url: 'https://www.razorblue.com/endpoints/chat.php',
        success: function (result) {
            if (result.chat === true) {
                chatBox.hide = false;
                $('.show-or-hide-chat').show();

            } else {
                chatBox.hide = true;
                $('.show-or-hide-chat').hide();
            }

            window.intercomSettings = {
                app_id: "vmkal9ma",
                hide_default_launcher: chatBox.hide
            };
        }
    });
}



function displayJobReferralField(referralId, otherId, selectBoxId, additionalInfoId) {
    var SelectVal = $(selectBoxId).val();

    if ((SelectVal === referralId) || SelectVal === otherId) {
        $(additionalInfoId).show();
    } else {
        $(additionalInfoId).hide();
    }
}

function jobApplicationFormAmends() {
    try {
        // Specific application form
        displayJobReferralField("9", "11", "#input_2_19", "#field_2_20");
        $( "#input_2_19" ).change(function() {
            displayJobReferralField("9", "11", "#input_2_19", "#field_2_20");
        });

        // Generic application form
        displayJobReferralField("9", "11", "#input_5_9", "#field_5_10");
        $( "#field_5_9" ).change(function() {
            displayJobReferralField("9", "11", "#input_5_9", "#field_5_10");
        });

    } catch (e) {
        //console.log("issue handling application forms or form not on page");
    }
}

function initializeDatePickerOnBookAMeetingForm() {
    const fieldId = '#input_6_19';

    // If the form and field is on the page, set the calendar.
    if ($(fieldId).length)
    {
        var dateTimeInput = $(fieldId);
        dateTimeInput.flatpickr({
        mode: "multiple",
        enableTime: true,
        dateFormat: "D J M Y, H:i",
        static: true,
        disable: [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);
            }
        ]
        });
    }
}

// This is to set any additional information for a form submission.
function setAdditionalInfoField(id, content) {
    $(id).val(content);
}


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
      // JavaScript to be fired on all pages
        // chat widget:
        $(".open-chat").click(function(e) {
          e.preventDefault();
          new Intercom('showNewMessage');
        });

        // code for logmein (remote support) integration
        var logMeInResponse, remoteSupport;
        try {
          logMeInResponse = (new URL(document.location)).searchParams.get("LogMeInRescueResponse");
          remoteSupport = (new URL(document.location)).searchParams.get("RemoteSupport");
        } catch (e) { // IE doesn't support searchParams, so use regex to search the query string for LogMeInRescueResponse= instead
          var qs = window.location.search;
          var resp = qs.match(/LogMeInRescueResponse=([^&]+)/);
          var remote = qs.match(/RemoteSupport=([^&]+)/);
          if (remote) {
            remoteSupport = true;
          }
          if (resp) {
            logMeInResponse = resp[1];
          }
        }
        // if there's a response (indicating a failed remote support form submission), open the modal and show error
        if (logMeInResponse) {
          var errorMessage;
          switch (logMeInResponse) {
            case "PINCODE_MISSING":
              errorMessage = "This service requires a PIN code";
              break;
            case "PINCODE_INVALID":
            case "PINCODE_ERROR":
              errorMessage = "The PIN code you have entered is invalid";
              break;
            case "PINCODE_EXPIRED":
              errorMessage = "The PIN code you have entered has expired";
              break;
            case "PINCODE_ALREADYUSED":
              errorMessage = "The PIN code you have entered has already been used";
              break;
            default:
              errorMessage = "Unfortunately an error occurred";
              break;
          }
          var errorDiv = $('<div class="pin-error">'+errorMessage+'</div>');
          errorDiv.insertBefore("#remoteSupportModal form");
          $("#remote-support-modal-open span").click();
        }
        else if (remoteSupport) {
          $("#remote-support-modal-open span").click();
        }

        // modify lists inside careers posts and case studies so that they are styled correctly. Without this admins
        // would have to always know to use the correct class and wrap all <li> text in a <span>. etc.
        $("body.page-template-template-vacancy .vacancy ul, .single-stories .main-story ul, .why-work-section ul, .responsibility-content ul, .main-post ul, .generic-content ul").each(function() {
          var list = $(this);
          list.addClass("blue");
          if ($("body").hasClass("single-careers")) {
            list.prev("p").addClass("career-listing-header");
          }
          list.children("li").each(function() {
            $(this).contents().wrap("<span></span>");
          });
        });

        // hover effects on success story images. Need to use delegation so that the hover effect still applies on Ajax-loaded posts
        // $(document).on("mouseenter", ".stories-wrapper .success-story", function() {
        //   var imageDiv = $(this).find(".story-img");
        //   if (!imageDiv.data("original-img")) {
        //     imageDiv.data("original-img", imageDiv.css("background-image"));
        //   }
        //   imageDiv.fadeOut(300, function() {
        //     imageDiv.css("background-image", "url('" + imageDiv.data("hover-img") + "')");
        //     imageDiv.fadeIn(300);
        //   });
        // });

        // $(document).on("mouseleave", ".stories-wrapper .success-story", function() {
        //   var imageDiv = $(this).find(".story-img");
        //   imageDiv.fadeOut(300, function() {
        //     imageDiv.css("background-image", imageDiv.data("original-img"));
        //     imageDiv.fadeIn(300);
        //   });
        // });

        // $(document).on("click", ".stories-wrapper .success-story", function() {
        //   window.location = $(this).find("a").attr("href");
        // });

          // Show/Hide Filter - Success Stories
          $('.sh-filter').click(function() {
            $(this).toggleClass('active');
            $('.filter-col_has-filters').slideToggle();

            if($(this).hasClass('active')) {
                $(this).children('.filter-txt').text("Hide Filters");
            } else {
                $(this).children('.filter-txt').text("Show Filters");
            }
          });
      },

      finalize: function() {
        initializeDatePickerOnBookAMeetingForm();
        jobApplicationFormAmends();

        /* Show chat box */
        try {
            showChatBox();
        } catch(e) {

        }

        /* Draw status icon in header */
        try {
            drawStatusIcon();
        } catch (e) {

        }

        /* Run coverage checker */
        try {
            CoverageCheckerStrip.run();
        } catch (e) {

        }

        // JavaScript to be fired on all pages, after page specific JS is fired

        try {
          $('.owl-carousel').owlCarousel({
            animateOut: 'slideOutDown',
            animateIn: 'flipInX',
            items: 1,
            margin: 0,
            stagePadding: 0,
            smartSpeed: 450,
            dots: false,
            loop: true
          });
        } catch (e) {
        }

        try {
          $('.match-height-1').matchHeight();
        } catch (e) {
        }
        try {
          $('.match-height-2').matchHeight();
        } catch (e) {
        }
        try {
          $('.match-height-3').matchHeight();
        } catch (e) {
        }
        try {
          $('.match-height-4').matchHeight();
        } catch (e) {
        }
        try {
          $('.match-height-5').matchHeight();
        } catch (e) {
        }

        // Prepend Lock image to Login Button (Desktop & Mobile)
        $('<img src="/wp-content/uploads/2019/11/log-in-icon-white.svg" class="img-fluid">').prependTo("#mega-menu-item-1120 a");
        $('<img src="/wp-content/uploads/2019/11/log-in-icon-white.svg" class="img-fluid">').prependTo("#mega-menu-item-1972 a");

        // Prepend Telephony image to Call Button (Mobile)
        $('<img src="/wp-content/uploads/2019/11/telephony-icon-white.svg" class="img-fluid">').prependTo("#mega-menu-item-3196 a");

        //  This JS prepends image to Sub-menu item - THIS NEEDS CHANGING TO BE MORE DYNAMIC (addition of icons to be relevant to each title)
        //  PrependTo target must be .nav-item-i

        // products and services grid menu
        $('<img src="/wp-content/uploads/2019/10/managed-it-icon-primary.svg" class="img-fluid">').prependTo(".header-icon-support-and-managed-it");
        $('<img src="/wp-content/uploads/2019/10/telephony-mobile-icon-primary.svg" class="img-fluid">').prependTo(".header-icon-telephony-and-mobile");
        $('<img src="/wp-content/uploads/2019/10/cloud-icon-primary.svg" class="img-fluid">').prependTo(".header-icon-cloud-and-datacentre");
        $('<img src="/wp-content/uploads/2019/10/connectivity-icon-primary.svg" class="img-fluid">').prependTo(".header-icon-superfast-connectivity");
        $('<img src="/wp-content/uploads/2019/10/cyber-security-icon-primary.svg" class="img-fluid">').prependTo(".header-icon-cybersecurity");
        $('<img src="/wp-content/uploads/2019/10/professional-services-icon-primary.svg" class="img-fluid">').prependTo(".header-icon-professional-services");
        $('<img src="/wp-content/uploads/2022/01/business-applications-icon-primary.svg" class="img-fluid">').prependTo(".header-icon-business-applications");
        $('<img src="/wp-content/uploads/2019/10/data-cabling-wifi-icon-primary.svg" class="img-fluid">').prependTo(".header-icon-building-infrastructure");

        // industries grid menu
        $('<img src="/wp-content/uploads/2019/10/manufacturing-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-1');
        $('<img src="/wp-content/uploads/2019/10/hospitality-leisure-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-7');
        $('<img src="/wp-content/uploads/2019/10/business-parks-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-4');
        $('<img src="/wp-content/uploads/2019/10/charities-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-8');
        $('<img src="/wp-content/uploads/2019/10/financial-legal-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-5');
        $('<img src="/wp-content/uploads/2019/10/healthcare-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-6');
        $('<img src="/wp-content/uploads/2019/10/logistics-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-9');
        $('<img src="/wp-content/uploads/2019/10/retailers-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-3');
        $('<img src="/wp-content/uploads/2019/10/government-education-icon-dark-blue.svg" class="img-fluid">').prependTo('#industries-single-item-2');

        /* This sets the margins on the products and services and industries menu on both load and on scroll */
        // setHeaderMargins();
        // $(document).scroll(function() {
        //     setHeaderMargins();
        // });

        // Add sticky class to header on Scroll
        var mainNav = $(".navigation-wrapper");
        var stickyDiv = "fixed-top";
        var mainHeader = $('.nav-master').height();

        // Replace image strapline if user scrolls further than mainHeader var height
        $(window).scroll(function() {
          if( $(this).scrollTop() > mainHeader ) {
            $('.brand > img').attr("src" , "/wp-content/uploads/2019/10/razorblue-logo-white.svg");
            mainNav.addClass(stickyDiv);
          } else {
            $('.brand > img').attr("src" , "/wp-content/uploads/2019/10/razorblue-logo-strap-white.svg");
            mainNav.removeClass(stickyDiv);
          }
        });

        var handled = false;

        var elemTop = $('.rt-kpi').offset().top;
        var elemBottom = elemTop + $('.rt-kpi').height();

        $(window).scroll(function() {

          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();

          if (((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) && !handled) {

            $('.kpi-stat .count-this strong').each(function() {

              var element = $(this);

              if (element.text().match(/\d+/g)) {
                var original = element.text();
                var text = original.replace(/\d+(\.\d+)?/g, '');

                $({ counter: 0 }).animate({ counter: original.replace(/[^0-9\.]/g, '') }, {
                  duration: 1000,
                  easing: 'swing',
                  step: function() {
                    element.text(Math.floor(this.counter) + text);
                  },
                  complete: function() {
                    element.text(original);
                  }
                });
              }
            });

            handled = true;
          }
        });

        // function screenClass() {
        //   if($(window).innerWidth() < 1013) {
        //     $('.brand > img').attr("src" , "/wp-content/uploads/2019/10/razorblue-logo-white.svg");
        //   } else {
        //     $('.brand > img').attr("src" , "/wp-content/uploads/2019/10/razorblue-logo-strap-white.svg");
        //   }
        // }
        //
        // screenClass();
        //
        // $(window).bind('width',function(){
        //   screenClass();
        // });

        // Allow user to expand sub-menu & then follow link on second click
        // Rotate psuedo element on click
        var a_href = $(this).attr('href');

          $('.mega-menu-item-has-children > a').click(function () {
            if(!$(this).parent().hasClass('mega-toggle-on')) {
              $(this).addClass('rotateThis');
              // $(this).attr('href');
              // alert("Href is:"+a_href);
            } else {
              $(this).removeClass('rotateThis');
            }
          });

          $('.mega-menu-item-has-children > a:after').click(function () {
            if($(this).parent().hasClass('mega-toggle-on')) {
              $(this).removeClass('mega-toggle-on');
            }
            e.preventDefault();
          });

          $('nav.mobile-nav li.mega-menu-item').on('open_panel', function() {
            var linkText = $(this).children("a").text();
            var href = $(this).children("a").attr("href");
            var newLink = $('<li class="mega-menu-item mega-menu-item-type-post_type"><a class="mega-menu-link" href="' + href + '" aria-expanded="false">' + linkText + '<span class="mega-indicator"></span></a></li>');
            newLink.insertBefore($(this).find("ul > li.mega-menu-item:first-child").eq(0));
            $(this).children("a").text("Back");
          });

          $('nav.mobile-nav li.mega-menu-item').on('close_panel', function() {
            var indexLink = $(this).children("ul").children("li.mega-menu-item:first-child").eq(0);
            var indexText = indexLink.children("a").eq(0).text();
            $(this).children("a").eq(0).text(indexText);
            indexLink.remove();
          });

        $("#findOfficeModal").one("shown.bs.modal", function() {
          var iFrame = $('<iframe src="/find-an-office/" style="width: 100%; min-height: 600px; border: none;"></iframe>');
          iFrame.appendTo("#findOfficeModal .modal-body");
        });

        // dirty hack to get the modal opening to trigger the event, for some reason Bootstrap doesn't seem to
        // do this itself, even though it's supposed to...
        $('[data-target="#findOfficeModal"] span').click(function() {
          // use setTimeout to allow it to load first
          setTimeout(function() {
            $("#findOfficeModal").trigger("shown.bs.modal");
          }, 0);
        });

        $('.close-btn').click(function () {
          $('.float-cta').css('display', 'none');
        });
      }
    },
    'home': {
      finalize: function() {
      }
    },
    'single_services': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        $('.gfield_label').matchHeight();
        $('.gfield').matchHeight();

        $('.single-offering-wrapper [data-target^="#formModal-"], .products-service-rows [data-target^="#formModal-"]').on("click", function() {
          var theTitle = $(this).data("title");
          var target = $(this).data("target");

          $(target + " .modal-title").text(theTitle);
        });

        jQuery(document).on('gform_confirmation_loaded', function(event, formId){
          setTimeout(window.location.reload, 3000);
      });
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page

        // debounce rate. Lower runs the animation more often as the user scrolls.
        // From experiment, needs to be no more than 15 (~60 per second) otherwise
        // if you scroll quickly and stop the events don't fade in
        var debounceInterval = 15;

        // maximum wait between successive events appearing, in a staggered
        // fashion as the user scrolls down
        var staggerRate = 500;

        // number of pixels off the bottom of the screen the year has to be
        // in order for it to fade into view
        var visibleOffset = 50;

        // Returns a function, that, as long as it continues to be invoked, will not
        // be triggered. The function will be called after it stops being called for
        // N milliseconds. If `immediate` is passed, trigger the function on the
        // leading edge, instead of the trailing.
        function debounce(func, wait, immediate) {
          var timeout;
          return function() {
              var context = this, args = arguments;
              var later = function() {
                  timeout = null;
                  if (!immediate) {
                    func.apply(context, args);
                  }
              };
              var callNow = immediate && !timeout;
              clearTimeout(timeout);
              timeout = setTimeout(later, wait);
              if (callNow) {
                func.apply(context, args);
              }
          };
        }

        function sizeCheck() {
          var breakPoint = 600;
          var elements = $(".year-bg");
          if (window.innerWidth <= breakPoint) {
            elements.addClass("mobile").removeClass("desktop");
          }
          else {
            elements.addClass("desktop").removeClass("mobile");
            elements.siblings(".events").show();
          }
        }

        function scrollFadeIn() {
          var screenBottom = $(window).scrollTop() + $(window).height();
          $(".year-bg.desktop").each(function() {
            if ($(this).siblings(".events").hasClass("hidden")) {
              var height = $(this).offset().top;
              if (height < screenBottom - visibleOffset) {
                  $(this).siblings(".events").removeClass("hidden");
                  setTimeout(debounce(scrollFadeIn, debounceInterval, true), staggerRate);
                  return false;
              }
              else {
                  return false;
              }
            }
          });
        }

        sizeCheck();
        scrollFadeIn();

        $(window).on("resize orientationchange", debounce(sizeCheck, 20, true));
        $(window).on("resize orientationchange", debounce(scrollFadeIn, debounceInterval, true));
        $(window).on("scroll", debounce(scrollFadeIn, debounceInterval, true));

        $(document).ready(function() {
          $(document).on("click", ".year-bg.mobile", function() {
            $(this).siblings(".events").slideToggle();
          });
        });
      }
    },

    'contact_us': {
      init: function() {},

      finalize: function() {
        var maps = $('.office-map-wrapper');
        maps.each(function() {
          var latlon = new google.maps.LatLng($(this).data('lat'), $(this).data('long'));
          var opts = {
              zoom: 15,
              center: latlon,
              mapTypeControl: false,
              streetViewControl: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP
          };
          var map = new google.maps.Map($(this).get(0), opts);
          var image = new google.maps.MarkerImage('/wp-content/uploads/2019/10/pin-icon.svg',
            new google.maps.Size(50, 50));
          var svg = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28.3px" height="40px" viewBox="0 0 167.55 236.71"><defs><style>.cls-1{fill:url(#linear-gradient);}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#fff;}</style><linearGradient id="linear-gradient" x1="83.78" y1="236.71" x2="83.78" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#0098ce"/><stop offset="1" stop-color="#3cb6aa"/></linearGradient><clipPath id="clip-path"><path class="cls-1" d="M84,236.71c18.18-27,36.35-53.84,54.87-80.64,10.67-15.45,20.63-31.75,25.69-49.83,10.19-36.45-6.08-76.76-39.18-95.38a85,85,0,0,0-83.17,0C9.1,29.48-7.18,69.79,3,106.24c5.05,18.08,15,34.38,25.69,49.83,18.51,26.8,36.69,53.62,54.86,80.64"/></clipPath><linearGradient id="linear-gradient-3" x1="95.93" y1="236.71" x2="95.93" y2="41.16" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#0098ce"/><stop offset="0.27" stop-color="#14a2c2"/><stop offset="0.73" stop-color="#31b1b1"/><stop offset="1" stop-color="#3cb6aa"/></linearGradient></defs><title>pin-icon</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M84,236.71c18.18-27,36.35-53.84,54.87-80.64,10.67-15.45,20.63-31.75,25.69-49.83,10.19-36.45-6.08-76.76-39.18-95.38a85,85,0,0,0-83.17,0C9.1,29.48-7.18,69.79,3,106.24c5.05,18.08,15,34.38,25.69,49.83,18.51,26.8,36.69,53.62,54.86,80.64"/><g class="cls-2"><path class="cls-3" d="M118.2,41.16l49.35,43.3h0a100.17,100.17,0,0,1-15.3,50.63l-10.46,16.66-58.22,85L24.31,149.58Z"/></g><g id="Layer_2-2" data-name="Layer 2"><g id="razorblue-logomark-white"><path class="cls-4" d="M83.16,92.9c-.48-1.82,2.89-3.41,4.15-3.74a4.23,4.23,0,0,1,2.81,0c10.8,5,22.65,7.45,34.27,9.4.75.11,11.88.87,12.4,2.89s-3.57,3.61-4.86,4c-5.24,1.45-30,.31-40.32,1.45a268.22,268.22,0,0,0-29.56,4.87c-5,1.08-11.15,3.42-16.35,3.16A1.8,1.8,0,0,1,44,113.77a2.73,2.73,0,0,1,1.18-2.42c9.81-8.13,41.88-20.21,55.88-23.94,3.68-1,7.39-1.86,11.11-2.72l2.39-.56.75-.2.38,0c.09.41-.74.38-1.08.6a8.22,8.22,0,0,1,2.67-1.23c1-.28,3.25-.51,3.59.87.47,1.81-2.88,3.39-4.14,3.74-1,.26-3.25.49-3.6-.89-.47-1.83,2.89-3.49,4.25-3.84,1-.26,3.25-.5,3.6.87.46,1.83-2.89,3.41-4.16,3.74-1,.26-3.24.51-3.59-.87-.47-1.89,2.89-3.49,4.19-3.85,1-.26,3.24-.49,3.58.88.48,1.82-2.88,3.39-4.14,3.74-1,.26-3.24.49-3.58-.88-.51-2,2.71-3.47,4.11-3.86,1-.26,3.24-.49,3.6.88.46,1.82-2.89,3.41-4.16,3.74-1,.29-3.31.48-3.67-1-.47-1.83,2.89-3.41,4.15-3.74,1-.26,3.23-.5,3.59.87.47,1.82-2.89,3.41-4.14,3.74a5.57,5.57,0,0,1-2.15.16c-.15,0-1.09-.34-.94-.36s-.15-.09-.22-.12l-.4-.14-1.17-.32L108,85.81a51.58,51.58,0,0,1-11.42-3.14c-12.48-5.78-14.56-13.18-23-22-.28-.3-.6-.39-.73-.85C72.42,58,75.77,56.39,77,56c1-.26,3.23-.49,3.58.87.46,1.83-2.89,3.4-4.15,3.74-1,.27-3.38.49-3.74-.91-.46-1.82,2.89-3.4,4.15-3.73,1-.27,3.25-.5,3.59.87.48,1.82-2.88,3.39-4.14,3.74-1,.26-3.35.56-3.71-.85-.46-1.82,2.89-3.4,4.14-3.73,1-.26,3.25-.51,3.6.87.46,1.83-2.89,3.49-4.25,3.84-1,.24-3.25.49-3.59-.88-.47-1.82,2.88-3.4,4.14-3.74,1-.26,3.25-.49,3.6.88.47,1.89-2.89,3.54-4.23,3.9-1,.26-3.24.5-3.59-.87-.46-1.82,2.89-3.41,4.15-3.74,1-.26,3.25-.51,3.6.87.62,2.44.49,6.13.89,8.66,2.66,16.65,3.94,31.4,2.54,48.24-.34,4.33-2.89,21.23-2.58,23.19s-2.89,3.33-4.16,3.69c-1,.26-3.25.49-3.6-.88-.46-1.81,2.89-3.4,4.15-3.73s3.28-.49,3.65,1c.48,1.82-2.89,3.39-4.14,3.74-1,.26-3.24.49-3.6-.88-.46-1.82,2.89-3.39,4.16-3.74a4.33,4.33,0,0,1,3,.1l-3.85.26,1.1-.36c1-.27,3.23-.51,3.59.88.46,1.82-2.89,3.39-4.16,3.73-1,.26-3.23.5-3.59-.87s1.25-1.83.62-1.66l.24-.36.32-.59,1-2.14,2.63-6c2.58-6,5-12.07,8.09-17.79C95,96,107.9,83.48,121.51,72.46l4.91-4,1.21-1,.43-.4.15-.15.14-.17a6.09,6.09,0,0,1,4-2.72c1-.26,3.25-.49,3.59.88.47,1.82-2.89,3.4-4.14,3.74-1,.26-3.25.49-3.6-.88-.52-2,2.76-3.56,4.18-3.94,1-.26,3.25-.49,3.59.88.46,1.82-2.89,3.4-4.16,3.73s-3.28.52-3.67-1c-.47-1.82,2.89-3.39,4.15-3.74,1-.26,3.25-.49,3.6.88.46,1.82-2.89,3.4-4.16,3.74-1,.28-3.4.45-3.77-1-.47-1.83,2.88-3.41,4.14-3.74,1-.27,3.25-.51,3.6.87.46,1.82-2.89,3.39-4.15,3.74a6.14,6.14,0,0,1-1.54.2h-.36c-8.86,1-18,4.65-26.45,6.89C81.9,81,59.56,82.34,37.65,82.11c-6.18,0-12.37-.45-18.56-.38h-.86l-.39.09L17,82c-.88.11-2.43.09-2.72-1-.46-1.82,2.89-3.39,4.15-3.72,1-.26,3.25-.51,3.59.86.47,1.87-3,3.51-4.33,3.85-1,.27-3.23.5-3.58-.87-.46-1.82,2.89-3.41,4.15-3.74,1-.26,3.23-.49,3.59.87.48,1.89-2.89,3.52-4.2,3.87-1,.26-3.25.5-3.6-.87-.46-1.82,2.89-3.39,4.15-3.74s3.29-.49,3.68,1c.46,1.82-2.89,3.41-4.16,3.75-1,.26-3.23.49-3.58-.87-.48-1.84,2.89-3.41,4.14-3.76a3.84,3.84,0,0,1,3.21.31c5.17,3.15,15.11,4.91,20.75,6.55C55,88.16,67.13,92.15,79,98.21a167.33,167.33,0,0,1,23.1,14.31c3.86,2.89,19.24,16.45,21.25,17.09a1.44,1.44,0,0,1,1,.94c.47,1.82-2.88,3.39-4.14,3.74-1,.26-3.24.49-3.6-.88-.46-1.82,2.89-3.4,4.16-3.74,1-.26,3.56-.49,3.92.91.46,1.83-2.89,3.41-4.16,3.74-1,.26-3.24.49-3.6-.87-.49-2,3.25-3.55,4.61-3.85l-2.76,1.24a8.3,8.3,0,0,1,2.79-1.35c1-.26,3.25-.49,3.58.89.46,1.82-2.89,3.39-4.15,3.72-1,.28-3.25.51-3.59-.87-.48-1.89,2.89-3.62,4.33-4,1-.26,3.24-.51,3.58.87.46,1.83-2.89,3.4-4.14,3.74-1,.27-3.24.5-3.58-.87s0-3.19-.31-4.8c-1.14-5.77-2.89-11.55-4.33-17.33-4.78-18.77-3.77-38.31-1-57.3.66-4.51,3.82-18.36,3.42-21.67-.29-1.93,2.69-3.33,4-3.71,1-.26,3.25-.49,3.6.88.46,1.82-2.89,3.4-4.14,3.73s-3.28.49-3.69-1.13,2.89-3.39,4.15-3.74c1-.26,3.25-.49,3.58.88.48,1.82-2.89,3.4-4.15,3.74-1,.28-3.35.46-3.72-1-.46-1.82,2.93-3.39,4.14-3.74,1-.26,3.25-.49,3.6.88.46,1.82-2.89,3.4-4.16,3.74-1,.26-3.41.52-3.77-.88-.48-1.83,2.89-3.39,4.15-3.74,1-.2,3.3-.49,3.59.87.48,1.87-3.12,3.52-4.33,3.87-1,.26-3.24.49-3.58-.88-.48-1.82,2.89-3.4,4.14-3.73,1-.26,3.24-.5,3.6.87a2,2,0,0,1-.64,1.69l-.36.39-.16.14c-3.1.75-46,89.89-65.28,95.06-.76.2-4,.91-4.33-.75-.62-2.4,4.46-4.09,6.2-3.91a3.93,3.93,0,0,0-1.45.1l-.55.17h-.23c19.11-12.87,51.56-86.61,61.48-93.14l.23-.13c1.59-.39,5-1.85,5.69.75.25.94-5.34,37.87-5.61,44.46-.65,15.31,1.66,28.26,5.41,43,1.45,5.78,6,15.48-2.15,17.65a12.45,12.45,0,0,1-2.19.25c-2.79.21-18.1-13.87-21.67-16.56a161.93,161.93,0,0,0-32-19C52.61,93.52,39.83,90.2,27,86.34L25.74,86l-1.29-.38c-.55-.21-10.3-2.91-10.28-4.21,0-2.62,2.22-3.4,4.33-4.22,1.45-.61,44.59-.33,53-1,18.2-1.61,34.43-6.23,52.09-11,1.53-.41,11.56-3.42,12.32-.71C136.7,67.7,120,79.9,117.37,82.2a136.32,136.32,0,0,0-12,12.36A96.87,96.87,0,0,0,92,114.45c-3.07,6.26-7.39,22.28-13.9,26.31a4.32,4.32,0,0,1-1.1.37c-1.17.31-3.37.47-3.77-1.11S76,114,76.3,109.27a143.16,143.16,0,0,0-1.44-30.95c-.09-.59-3.5-17.83-2.29-19.48S74.81,57,76.91,56a13.16,13.16,0,0,1,2.51,0c1.89.8,12.51,15.89,19.68,20.22,5.33,3.28,20.73,5.26,21.86,7.66.43.94-1.29,2.63-1.95,3-5.25,3-12.48,3.59-18.33,5.15A183.41,183.41,0,0,0,68,104.13C64.21,106,54.46,112,50.51,113.06a4.36,4.36,0,0,0,.92-.9l.36-1-.55-.93-.84-.33H50A269.9,269.9,0,0,1,105,101c9.58-.49,19.21.19,28.74-.43l-1.36.33a39,39,0,0,0-3.14,2.34l.17,1.69.4.23c-2.88-1.44-45.32-7-46.66-12.3"/></g></g></g></g></svg>';
          var mark = new google.maps.Marker({
              position: latlon,
              title: 'Razorblue',
              icon: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg)
          });
          mark.setMap(map);
        });
      }
    },

    'check_availability': {
        init: function () {
        },

        finalize: function () {
            CoverageCheckerResults.run();
        }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
